/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out your grade point average on the 4.0 scale. Add each course with its letter grade and credit hours — the GPA is weighted by credits automatically.`)
};

const es_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula tu promedio académico (GPA) en la escala de 4.0. Añade cada asignatura con su nota y sus créditos — el promedio se pondera automáticamente por créditos.`)
};

const de_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne deinen Notendurchschnitt auf der 4,0-Skala. Trage jeden Kurs mit Notenbuchstaben und Kreditstunden ein — der GPA wird automatisch nach Credits gewichtet.`)
};

const nl_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken je gemiddelde cijfer (GPA) op de schaal van 4,0. Voeg elk vak toe met het lettercijfer en aantal studiepunten — de GPA wordt automatisch gewogen naar studiepunten.`)
};

const fr_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez votre moyenne pondérée (GPA) sur l'échelle de 4,0. Ajoutez chaque cours avec sa note en lettre et ses crédits — le GPA est pondéré automatiquement par les crédits.`)
};

const it_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la tua media voti nella scala 4.0. Aggiungi ogni corso con il suo voto in lettere e i crediti — il GPA viene ponderato automaticamente in base ai crediti.`)
};

const pt_br2_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule seu GPA (média de pontos por nota) na escala de 4,0. Adicione cada disciplina com sua nota em letra e a carga horária — o GPA é ponderado por créditos automaticamente.`)
};

const pt_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a sua média de pontuação (GPA) na escala de 4,0. Adicione cada disciplina com a sua nota em letra e horas de crédito — o GPA é ponderado automaticamente pelos créditos.`)
};

const ja_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.0スケールでの平均成績点(GPA)を算出します。各科目の成績評価と単位数を入力するだけで、GPAは自動的に単位数で加重計算されます。`)
};

const zh_gpa_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算你在 4.0 制下的平均绩点。添加每门课程的等级成绩和学分——GPA 会自动按学分加权计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_intro", locale)
	if (locale === "en") return en_gpa_intro(inputs)
	if (locale === "es") return es_gpa_intro(inputs)
	if (locale === "de") return de_gpa_intro(inputs)
	if (locale === "nl") return nl_gpa_intro(inputs)
	if (locale === "fr") return fr_gpa_intro(inputs)
	if (locale === "it") return it_gpa_intro(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_intro(inputs)
	if (locale === "pt") return pt_gpa_intro(inputs)
	if (locale === "ja") return ja_gpa_intro(inputs)
	return zh_gpa_intro(inputs)
};